module.exports = require('./lib/patch');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-hot-loader/patch.js
 ** module id = 1
 ** module chunks = 0
 **/